export enum FeatureType {
  Product = 'product',
  Development = 'development',
}

export interface FeatureSet {
  [key: string]: FeatureStatus
}

export interface FeatureStatus {
  id: number
  type: FeatureType
  key: string
  name: string
  enabled: boolean
}
